<template>
  <div id="conexaoCaixaIntegracao">
    <!-- Gate de permissao no painel INTEIRO, como nos demais paineis de Integracoes:
         sem ConexaoCaixas.gerenciar o usuario nao ve nem o toggle do modulo. -->
    <card-section-sem-permissao v-if="semPermissao" />

    <div v-else-if="loadingConfiguracoes" class="text-center">
      <q-spinner color="blue-7" size="3em" />
    </div>

    <div v-else>
      <q-list padding>
        <q-item tag="label">
          <q-item-section side>
            <q-toggle v-model="ativo" color="green" :disable="salvando" @update:model-value="salvarAtivo" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Módulo ativo</q-item-label>
            <q-item-label caption>
              Habilita a geração de relatórios do Painel Parceiros Caixa a partir do
              computador da lotérica.
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>

      <q-separator class="q-my-md" />

      <ConexaoCaixaVinculo v-if="ativo" />

      <!-- Sem q-banner: nenhum painel vizinho de Integracoes usa. -->
      <div v-else class="text-grey-7">
        Ative o módulo acima para configurar a conexão.
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ConexaoCaixaVinculo from "@/components/ConexaoCaixa/ConexaoCaixaVinculo.vue";

export default {
  name: "ConexaoCaixaIntegracao",

  components: { ConexaoCaixaVinculo },

  data() {
    return {
      ativo: false,
      salvando: false,
      loadingConfiguracoes: true,
      semPermissao: false,
    };
  },

  async mounted() {
    // 403 = usuario sem ConexaoCaixas.gerenciar. O interceptor resolve erro como
    // { error }, entao o status vive em res.error.response.status — nunca .catch().
    const res = await this.fetchConexaoCaixaConfig();
    if (res && res.error && res.error.response && res.error.response.status === 403) {
      this.semPermissao = true;
      this.loadingConfiguracoes = false;
      return;
    }

    const config = this.$store.state.conexao_caixa.conexaoCaixaConfig || {};
    this.ativo = config.conexao_caixa_ativo === "1";
    this.loadingConfiguracoes = false;
  },

  methods: {
    ...mapActions(["fetchConexaoCaixaConfig", "salvarConexaoCaixaConfig"]),

    async salvarAtivo(valor) {
      this.salvando = true;
      // Só o flag do módulo. CPF é responsabilidade do painel de ativação; senha e
      // segredo de webhook saíram do frontend de vez.
      const res = await this.salvarConexaoCaixaConfig({
        conexao_caixa_ativo: valor ? "1" : "0",
      });
      this.salvando = false;

      if (res && res.error) {
        this.ativo = !valor;
        this.$q.notify({
          message: (res.error.message) || "Erro ao salvar.",
          color: "red",
          position: "top-right",
        });
        return;
      }

      this.$q.notify({ message: "Configuração salva.", color: "green", position: "top-right" });
    },
  },
};
</script>
